import { InputLabel } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LabelTypography = styled(InputLabel)(({theme}) => ({
  fontStyle: 'normal',
  fontWeight: '500',
  fontSize: '1em', 
  paddingLeft: '1em',
  display: 'flex',
  alignItems: 'center',
  color: theme.inputLabel.color
}));
